import { $ as $effect, f as fail, s as succeed, a as fromAsync, b as $next, c as some, n as none, p as pipe, m as map, d as succeedAsync, e as $exec, t as trySync, g as tryPromise } from '../lib/tools-DNR0sPnt.mjs';
export { U as UnknownError, x as failAsync, y as failAsyncWith, V as flatMap, W as flatMapSpread, B as fromBoolean, C as fromCoerced, z as fromCondition, E as fromExpression, A as fromNullable, D as invert, v as left, O as mapAsync, S as mapAsyncSpread, X as mapError, Z as mapErrorAsync, j as mapErrorDefault, k as mapErrorEffectDefault, i as mapErrorEffectPassThrough, h as mapErrorPassThrough, Y as mapLeft, _ as mapLeftAsync, N as mapRight, P as mapRightAsync, T as mapRightAsyncSpread, R as mapRightSpread, Q as mapSpread, a0 as pipeMap, q as promise, r as promiseEffect, I as promiseEffectImmediate, H as promiseImmediate, a1 as returnsEffect, u as right, w as succeedAsyncWith, l as sync, o as syncEffect, G as syncEffectImmediate, F as syncImmediate, K as tryPromiseImmediate, M as tryRunPromise, L as tryRunSync, J as trySyncImmediate } from '../lib/tools-DNR0sPnt.mjs';
import { l as limit2 } from '../lib/limit2-B1aIcHAv.mjs';
import '../lib/array-DNG3qZDq.mjs';

var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
class AggregatedError extends AggregateError {
  /**
 *
 *
 *
 *
 */
  constructor(errors, message) {
    super(errors, message);
    __publicField(this, "name", "AggregatedError");
    /**
 *
 */
    __publicField(this, "errors");
    this.errors = [...errors];
  }
  static stringifyError(expand, e) {
    if (e instanceof AggregatedError) return e.toString(expand);
    if (e instanceof Error) return e.stack ?? e.message;
    return `${e}`;
  }
  /**
 *
 *
 *
 *
 */
  toString(expand = false) {
    if (!expand || this.errors.length === 0) {
      return super.toString();
    }
    const message = this.stack ?? super.toString();
    const msgs = this.errors.map(AggregatedError.stringifyError.bind(this, expand)).join(`
${"-".repeat(10)}
`).split("\n").map((m) => `    ${m}`).join("\n");
    return `${message}

  Aggregated Errors:

${msgs}`;
  }
}

function aggregateFailures(results, message) {
  const failed = results.filter((res) => res[$effect] === "left");
  return failed.length > 0 ? fail(
    new AggregatedError(
      failed.map(([error]) => error),
      message ?? "One or more effects failed to resolve"
    )
  ) : succeed(results.map(([, value]) => value));
}

function allSync(effects, options = {}) {
  return aggregateFailures(effects, options.message);
}
function allAsync(effects, options = {}) {
  return fromAsync(Promise.all(effects).then((v) => aggregateFailures(v, options.message)));
}

function catchError(handler) {
  const onFailure = (e) => handler(e.left);
  return (effect) => effect[$next](void 0, onFailure);
}
const catchFailure = catchError;
function catchErrorAsync(handler) {
  const onFailure = (e) => fromAsync(handler(e.left));
  return (effect) => effect[$next](void 0, onFailure);
}
const catchFailureAsync = catchError;
function catchType(type, handler) {
  const onFailure = (e) => e.left instanceof type ? handler(e.left) : e;
  return (effect) => effect[$next](void 0, onFailure);
}
function catchTypeAsync(type, handler) {
  const onFailure = (e) => e.left instanceof type ? fromAsync(handler(e.left)) : e;
  return (effect) => effect[$next](void 0, onFailure);
}
function catchName(name, handler) {
  const onFailure = (e) => {
    const err = e.left;
    return typeof err === "object" && !!err && "name" in err && err.name === name ? handler(err) : e;
  };
  return (effect) => effect[$next](void 0, onFailure);
}
function catchNameAsync(name, handler) {
  const onFailure = (e) => {
    const err = e.left;
    return typeof err === "object" && !!err && "name" in err && err.name === name ? fromAsync(handler(err)) : e;
  };
  return (effect) => effect[$next](void 0, onFailure);
}
function catchSome(handler) {
  const onFailure = (e) => {
    const res = handler(e.left);
    return res[$effect] === "right" ? res[1] : e;
  };
  return (effect) => effect[$next](void 0, onFailure);
}

const pushWithOptions = (array, value, flatValue) => {
  array.push(...flatValue && Array.isArray(value) ? value : [value]);
};
function concatenate(input, result, options) {
  const { flatInput = true, flatResult = true } = options;
  const resultArray = [];
  pushWithOptions(resultArray, input, flatInput);
  pushWithOptions(resultArray, result, flatResult);
  return succeed(resultArray);
}
const mapConcat = (mapper, options = {}) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    (e) => concatenate(e[1], mapper(e[1]), options)
  )
);
const mapConcatSpread = (mapper, options = {}) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    (e) => concatenate(e[1], mapper(...e[1]), options)
  )
);
const mapConcatAsync = (mapper, options = {}) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    (e) => fromAsync(mapper(e[1]).then((result) => concatenate(e[1], result, options)))
  )
);
const mapConcatAsyncSpread = (mapper, options = {}) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    (e) => fromAsync(mapper(...e[1]).then((re) => concatenate(e[1], re, options)))
  )
);
const flatMapConcat = (mapper, options = {}) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    (e) => (
      /*                               */
      /*                                                                                                        */
      /*                                                                                                      */
      mapper(e[1])[$next]((re) => concatenate(e[1], re[1], options))
    )
  )
);
const flatMapConcatSpread = (mapper, options = {}) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    (e) => (
      /*                               */
      /*                                                                                                        */
      /*                                                                                                      */
      mapper(...e[1])[$next]((re) => concatenate(e[1], re[1], options))
    )
  )
);

const isRight = (effect) => effect[$effect] === "right";
const isSome = isRight;
const isSuccess = isRight;
const isLeft = (effect) => effect[$effect] === "left";
const isNone = isLeft;
const isFailure = isLeft;

function mapIf(handler) {
  return (effect) => effect[$next]((e) => e[1] ? handler.onTrue() : handler.onFalse());
}
function ifImmediate(condition, {
  onTrue,
  onFalse
}) {
  return mapIf({ onTrue, onFalse })(succeed(condition));
}
function mapIfEffect(condition, handler) {
  const onSucceed = (e) => condition ? handler.onTrue(e[1]) : handler.onFalse(e[1]);
  return (effect) => effect[$next](onSucceed);
}
function when(predicate) {
  const onSucceed = (e) => succeed(predicate(e[1]) ? some(e[1]) : none());
  return (effect) => effect[$next](onSucceed);
}
function whenEffect(predicate) {
  const onSucceed = (e) => {
    return pipe(
      predicate(e[1]),
      map((p) => p ? succeed(e[1]) : fail(void 0))
    );
  };
  return (effect) => effect[$next](onSucceed);
}
function unless(predicate) {
  const onSucceed = (e) => succeed(predicate(e[1]) ? fail(void 0) : succeed(e[1]));
  return (effect) => effect[$next](onSucceed);
}

function mapEach(mapper) {
  const onSuccess = (e) => succeed(e[1].map(mapper));
  return (effect) => effect[$next](onSuccess);
}
function mapEachAsync(mapper) {
  const onSuccess = (e) => succeedAsync(Promise.all(e[1].map(mapper)));
  return (effect) => effect[$next](onSuccess);
}
function mapEachLimit(mapper, options) {
  const onSuccess = (e) => succeedAsync(limit2(e[1], mapper, options));
  return (effect) => effect[$next](onSuccess);
}
function flatMapEach(mapper, options) {
  const onSuccess = (e) => {
    const r = e[1].map(mapper);
    if (r[0] && r[0][$exec] === "async") {
      return fromAsync(
        Promise.all(r).then(
          (re) => aggregateFailures(re, options?.message)
        )
      );
    }
    return aggregateFailures(r, options?.message);
  };
  return (effect) => effect[$next](onSuccess);
}
function flatMapEachLimit(mapper, options) {
  const onSuccess = (e) => fromAsync(limit2(e[1], mapper, options).then((v) => aggregateFailures(v, options?.message)));
  return (effect) => effect[$next](onSuccess);
}

function match(param) {
  const onSucceedWrapper = (e) => succeed(param.onSucceed(e[1]));
  const onFailWrapper = (e) => succeed(param.onFail(e[0]));
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
function matchAsync(param) {
  const onSucceedWrapper = (e) => succeedAsync(param.onSucceed(e[1]));
  const onFailWrapper = (e) => succeedAsync(param.onFail(e[0]));
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}
function matchEffect(param) {
  const onSucceedWrapper = (e) => param.onSucceed(e[1]);
  const onFailWrapper = (e) => param.onFail(e[0]);
  return (effect) => effect[$next](onSucceedWrapper, onFailWrapper);
}

function policy(options) {
  if (Object.values(options).every((v) => v === void 0)) {
    throw new Error("You must provide at least one option to the policy function");
  }
  const { times = 0, delay = 0 } = options;
  let currentRetry = 0;
  const until = options.until ?? (() => times && currentRetry >= times);
  return (failure) => {
    currentRetry += 1;
    return until(failure[0]) ? failure : succeedAsync(
      new Promise((r) => {
        if (delay) {
          setTimeout(() => r(true), delay);
          return;
        }
        r(true);
      })
    );
  };
}
function retry(task, retryPolicy) {
  const retrier = async (args) => {
    const errors = [];
    while (true) {
      const res = await task(...args);
      if (isSuccess(res)) {
        return res;
      }
      errors.push(res[0]);
      const policyRes = await retryPolicy(res);
      if (isFailure(policyRes)) {
        return fail(
          new AggregatedError(
            [...errors, policyRes[0]],
            `Retry operation failed with last failure being: ${policyRes[0]}`
          )
        );
      }
    }
  };
  return (...args) => fromAsync(retrier(args));
}

const tap = (handler) => /*           */ ((onSucceed) => (effect) => effect[$next](onSucceed))((e) => (handler(e[1]), e));
const tapRight = tap;
const tapSpread = (handler) => /*           */ ((onSucceed) => (effect) => effect[$next](onSucceed))((e) => (handler(...e[1]), e));
const tapRightSpread = tapSpread;
const tapAsync = (handler) => /*           */ ((onSucceed) => (effect) => effect[$next](onSucceed))((e) => fromAsync(handler(e[1]).then(() => e)));
const tapRightAsync = tapAsync;
const tapAsyncSpread = (handler) => /*           */ ((onSucceed) => (effect) => effect[$next](onSucceed))((e) => fromAsync(handler(...e[1]).then(() => e)));
const tapRightAsyncSpread = tapAsyncSpread;
const tapError = (handler) => /*           */ ((onFail) => (effect) => effect[$next](void 0, onFail))((e) => (handler(e[0]), e));
const tapLeft = tapError;
const tapErrorAsync = (handler) => {
  return /*           */ ((onFail) => (effect) => effect[$next](void 0, onFail))((e) => fromAsync(handler(e[0]).then(() => e)));
};
const tapLeftAsync = tapErrorAsync;
const tapAny = (handler) => /*           */ ((onSucceed, onFail) => (effect) => effect[$next](onSucceed, onFail))(
  (e) => (handler(e[1]), e),
  (e) => (handler(e[0]), e)
);
const tapAnyAsync = (handler) => /*           */ ((onSucceed, onFail) => (effect) => effect[$next](onSucceed, onFail))(
  (e) => fromAsync(handler(e[1]).then(() => e)),
  (e) => fromAsync(handler(e[0]).then(() => e))
);
const tapMatch = (params) => /*           */ ((onSucceed, onFail) => (effect) => effect[$next](onSucceed, onFail))(
  (e) => (params.onSucceed(e[1]), e),
  (e) => (params.onFail(e[0]), e)
);
const tapMatchAsync = (params) => /*           */ ((onSucceed, onFail) => (effect) => effect[$next](onSucceed, onFail))(
  (e) => fromAsync(params.onSucceed(e[1]).then(() => e)),
  (e) => fromAsync(params.onFail(e[0]).then(() => e))
);

const tryMap = (mapper, mapErr) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    trySync((e) => mapper(e[1]), mapErr)
  )
);
const tryMapSpread = (mapper, mapErr) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    trySync((e) => mapper(...e[1]), mapErr)
  )
);
const tryMapAsync = (mapper, mapErr) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                 */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    tryPromise((e) => mapper(e[1]), mapErr)
  )
);
const tryMapAsyncSpread = (mapper, mapErr) => (
  /*                                                        */
  /*           */ ((onSuccess) => (
    /*                                            */
    (effect) => effect[$next](onSuccess)
  ))(
    /*                                                */
    tryPromise((e) => mapper(...e[1]), mapErr)
  )
);

function unbox(unboxer = (_) => _) {
  return (effect) => effect[$exec] === "async" ? effect.then((e) => unboxer(e[0] ?? e[1])) : unboxer(effect[0] ?? effect[1]);
}
function unboxThrow(unboxer = (_) => _) {
  const valueOrThrow = (effect) => {
    if (effect[0]) throw effect[0];
    return unboxer(effect[1]);
  };
  return (effect) => effect[$exec] === "async" ? effect.then(valueOrThrow) : valueOrThrow(effect);
}

export { AggregatedError, allAsync, allSync, catchError, catchErrorAsync, catchFailure, catchFailureAsync, catchName, catchNameAsync, catchSome, catchType, catchTypeAsync, fail, flatMapConcat, flatMapConcatSpread, flatMapEach, flatMapEachLimit, ifImmediate, isFailure, isLeft, isNone, isRight, isSome, isSuccess, map, mapConcat, mapConcatAsync, mapConcatAsyncSpread, mapConcatSpread, mapEach, mapEachAsync, mapEachLimit, mapIf, mapIfEffect, match, matchAsync, matchEffect, none, pipe, policy, retry, some, succeed, succeedAsync, tap, tapAny, tapAnyAsync, tapAsync, tapAsyncSpread, tapError, tapErrorAsync, tapLeft, tapLeftAsync, tapMatch, tapMatchAsync, tapRight, tapRightAsync, tapRightAsyncSpread, tapRightSpread, tapSpread, tryMap, tryMapAsync, tryMapAsyncSpread, tryMapSpread, tryPromise, trySync, unbox, unboxThrow, unless, when, whenEffect };
/*                              */
